import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './../firebase';
import { Link, useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [loginError, setLoginError] = useState(null);
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError(null);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      // Signed in
      const userLogged = userCredential.user;
      console.log('userLogged', userLogged);
      navigate('/');
      // ...
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log('error login user', errorCode, errorMessage);
      setLoginError(errorCode.replace('auth/', ' '));
    }
  };

  return (
    <div className="flex items-center h-full mt-24 animate__animated animate__fadeIn mb-3">
      <div className="relative flex flex-col items-center justify-center grow">
        <div className="w-full md:p-6 px-2 bg-white rounded-md md:shadow-md md:max-w-xl md:border-t">
          <h1 className="text-3xl font-bold text-center text-gray-700">
            AL Business House
          </h1>
          <form className="mt-6">
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-semibold text-gray-800"
              >
                Email
              </label>
              <input
                type="email"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Password
              </label>
              <input
                type="password"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {loginError && (
              <p className="text-xs text-rose-500">{loginError}</p>
            )}
            <div className="mt-2">
              <button
                className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600"
                onClick={(e) => handleLogin(e)}
              >
                Login
              </button>
            </div>
          </form>

          <p className="mt-4 text-sm text-center text-gray-700">
            Don't have an account?{' '}
            <Link
              to="/signup"
              className="font-medium text-blue-600 hover:underline"
            >
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
